<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>异步回调</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">请将通知地址发给快付运营配置。</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>机构号</td><td>orgCd</td><td>String（32）</td><td>是</td><td></td></tr>
          <tr><td>商户号</td><td>mchtCd</td><td>String（20）</td><td>是</td><td></td></tr>
          <tr><td>商户名</td><td>mchtName</td><td>String（150）</td><td>是</td><td></td></tr>
          <tr><td>平台流水号</td><td>orderCd</td><td>String(20)</td><td>是</td><td></td></tr>
          <tr><td>外部订单号</td><td>outOrderId</td><td>String（32）</td><td>是</td><td></td></tr>
          <tr><td>交易状态</td><td>transStatus</td><td>String（10）</td><td>是</td><td>100-支付成功（支付订单）或退款成功（退款订单）,
            101-待支付, 102-支付失败（支付订单）或退款失败（退款订单）,103-订单处理中,104-已撤销
          </td></tr>
          <tr><td>提现账户编号</td><td>payerCd</td><td>String（16）</td><td>是</td><td></td></tr>
          <tr><td>交易金额</td><td>transAmt</td><td>String（16）</td><td>是</td><td>单位：元（最多两位小数）</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'AsynNotice',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/acct/userreg', 'name': '用户注册'},
        {'url': '/interface/acct/userbindcard', 'name': '用户绑卡'},
        {'url': '/interface/acct/splitacct', 'name': '分账'},
        {'url': '/interface/acct/transfer', 'name': '转账'},
        {'url': '/interface/acct/cash', 'name': '提现'},
        {'url': '/interface/acct/querybalance', 'name': '用户余额查询'},
        {'url': '/interface/acct/queryorder', 'name': '交易查询'},
        {'url': '/interface/acct/asynnotice', 'name': '异步回调'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/acct/asynnotice.vue